import React, { useState } from 'react';
import { string } from 'prop-types';
import classNames from 'classnames';

import css from './ToolLogo.css';

// Fixed CSS dimensions matter: pill widths are measured before the image
// loads (see the overflow logic in ListingUserCard), so the logo must not
// change the pill size when it arrives.
const ToolLogo = ({ logoUrl, className }) => {
  const [failed, setFailed] = useState(false);

  if (!logoUrl || failed) {
    return null;
  }

  return (
    <img
      className={classNames(css.root, className)}
      src={logoUrl}
      alt=""
      loading="lazy"
      onError={() => setFailed(true)}
    />
  );
};

ToolLogo.defaultProps = {
  logoUrl: null,
  className: null,
};

ToolLogo.propTypes = {
  logoUrl: string,
  className: string,
};

export default ToolLogo;
